export const BNK_JETTON_ADDRESS = "EQAj1qW6WZTd7sd33Uk48O3TqxNPMjYrgwRHAcBM8RcQCQAD";
export const ARC_JETTON_ADDRESS = "EQBXRdZTk5P49mL0nOYfDR1VR33N3sPUgB7PNQMaj6DhxOJH";
export const NATIVE_TON_ADDRESS = "EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c";
export const TETHER_USDT_ADDRESS = "EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs";
export const SHKIP_JETTON_ADDRESS = "EQAHTR-wH0wb4oPrrVxmQS5R_qivJcnqvb3uFJ0v1Dw9qrpy";
export const bnkTokenAssetData = {
    asset: {
        blacklisted: false,
        community: false,
        contract_address: BNK_JETTON_ADDRESS,
        decimals: 0,
        default_symbol: false,
        deprecated: false,
        display_name: "BNK jetton",
        image_url: "data:image/png;base64, UklGRtwCAABXRUJQVlA4TM8CAAAv/8A/AP9gpm2b8qfsSbnGgSDbZv60L8Hnf/7r0DeggB2AHSgOxc6hOOwUAA84FGBAoq09VeyAOBxkLpzKtFor5P3fc4xMXEl6N6L/Dty2cST5+ul6mczM7j4A1M/pP6f/nP5z+s8fQOqSn1PVm8mbl/iss/+wBomLRWF/Nz5r7e/o+votuq5+s66l/56uoU+ga+n3qa65a9UV9G2YX5/WPDTr6vmA5A1dNR/J27p6PomumU+oK+UT6/r4h+iq+IfpWvgH68r4dcp5quS6Hn59dJtv062Q68L6NB/SA8TXa6D+t1n73S9Tof4HilWafU/d0KydMS07Wt0Js/PUDU1tfyNJdS8KmbzGuJqm3MlrkVESOuoaYzWNmahrEVvl4EleXg6t3MgL0m9yMJCXlxb5kOYKc7f3RaLUozy2K1QVCrKvr21W41mKNusizzUJiBi3lN3Pgayaum0/ZrFJ29/Zcc9bDdzxyH+m7jbDo5Y8dyutB9KQaknd6W5WrAit8nNAL8WFYNGehJpMpjFZT8A3jieBoiy2iaIpkFsYQVXgs0VSCrKRN7eAHlBayIk+AWgMwI8xhhDHGUAPjsqfX3puUyGDPDMvH0j54FkEGaYNcjAaLpFr4qlyRZLFDwaeRBCE1XLEFZAkC8OdXUCWLB270wtIk/XG6kKbKkiUrynGreoiHr99vyKegBQQEQv21H3E02EvKM0V5IpvbBRyY6VcWhvQ7Tuc3yo2T/85KWMag/e2cQk8t513b12Azu9k+2wuHo/FnnoYi0Ss3rBKKOKQLb+FDoXhi3pLXZJsSEP3Bc+8YRkvCN8N00xykLiSBDofIosEgZa73xZQkdtS3hf91zv6TzhTSsiaUolJkLW4UnoKMOLWG+ZxRZQt7mo8+jYZNCqPvmUJyMy3uMwWOba+XC1/HCh/hX3yv6uh7xinvy2gfk7/Of3n9J/Tf/4IAQA=",
        kind: "Jetton",
        priority: 0,
        symbol: "BNK",
        tags: [],
        taxable: false,
    },
};
export const usdtAssetData = {
    asset: {
        contract_address: "EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs",
        symbol: "USD₮",
        display_name: "Tether USD",
        priority: 100,
        image_url: "https://asset.ston.fi/img/EQCxE6mUtQJKFnGfaROTKOt1lZbDiiX1kCixRv7Nw2Id_sDs/3c568dd0c7f9b8874fe1aba3d318d38437615f06b01a46618bfe3c0eee5fe37f",
        decimals: 6,
        kind: "Jetton",
        deprecated: false,
        community: false,
        blacklisted: false,
        default_symbol: true,
        taxable: false,
        tags: [
            "high_liquidity",
            "asset:popular",
            "default_symbol",
            "asset:essential",
            "asset:default_symbol",
            "asset:liquidity:very_high",
        ],
        third_party_usd_price: "1.0",
        third_party_price_usd: "1.0",
        dex_usd_price: "1.000000000000000",
        dex_price_usd: "1.000000000000000",
    },
};
export const tonAssetData = {
    asset: {
        contract_address: "EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c",
        symbol: "TON",
        display_name: "TON",
        priority: 96,
        image_url: "https://asset.ston.fi/img/EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c/ee9fb21d17bc8d75c2a5f7b5f5f62d2bacec6b128f58b63cb841e98f7b74c4fc",
        decimals: 9,
        kind: "Ton",
        deprecated: false,
        community: false,
        blacklisted: false,
        default_symbol: true,
        taxable: false,
        tags: ["asset:default_symbol", "default_symbol", "asset:essential"],
    },
};
export const arcAssetData = {
    asset: {
        contract_address: "EQBXRdZTk5P49mL0nOYfDR1VR33N3sPUgB7PNQMaj6DhxOJH",
        symbol: "ARC",
        display_name: "ARC jetton",
        priority: 0,
        image_url: "https://asset.ston.fi/img/EQBXRdZTk5P49mL0nOYfDR1VR33N3sPUgB7PNQMaj6DhxOJH/7389cc59bf97736ab29847b346bcf84a6b9a265f1c13c1894c9abd776c849830",
        decimals: 9,
        kind: "Jetton",
        deprecated: false,
        community: true,
        blacklisted: false,
        default_symbol: false,
        taxable: false,
        tags: ["no_liquidity", "asset:liquidity:no"],
    },
};
export const shkipAssetData = {
    asset: {
        contract_address: SHKIP_JETTON_ADDRESS,
        symbol: "SHKIP",
        priority: 0,
        display_name: "Shkipper coin",
        image_url: "https://shkippercoin.github.io/offchain-data/SHKIP.png",
        decimals: 9,
        kind: "Jetton",
        deprecated: false,
        community: true,
        blacklisted: false,
        default_symbol: false,
        taxable: false,
        tags: [],
    },
};
//# sourceMappingURL=tokens.js.map